<div class="featured-products">
  <h3>Featured Products</h3>
  <div class="grid">
    <div class="col-3" *ngFor="let product of featuredProducts">
      <products-product-item [product]="product"></products-product-item>
    </div>
  </div>
</div>
